/*
 * @Author: 牛字杰 niuzijie@.jtexpress
 * @Date: 2022-07-13 15:34:22
 * @LastEditors: niuzijie
 * @LastEditTime: 2024-04-11 14:36:54
 * @FilePath: \yl-wxcx-coupon-front\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueCookie from 'vue-cookie'
import App from './App.vue'
import store from './store/index'
import createdRoute from './router'
import { Popup, Area, Toast, Tab, Tabs } from 'vant'
import 'vant/lib/index.css'
// import 'element-ui/lib/theme-chalk/index.css'
// import Antd from 'ant-design-vue'
import { Button, FormModel, Input, Popover, message, Checkbox } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import md5 from 'js-md5'
import VueMeta from 'vue-meta'
import VConsole from 'vconsole'

const { VUE_APP_ENV } = process.env
console.log('🚀 ~ VUE_APP_ENV:', VUE_APP_ENV)
const envArr = ['uat', 'development']
if (envArr.includes(VUE_APP_ENV)) {
  const vConsole = new VConsole()
  Vue.use(vConsole)
}

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
})
// const ElementUI = require('element-ui')
Vue.component(Button.name, Button)
Vue.use(FormModel)
Vue.use(Input)
Vue.use(Popover)
Vue.use(message)
// Vue.use(Antd)
Vue.use(Popup)
Vue.use(Area)
Vue.use(Toast)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Checkbox)
// Vue.use(ElementUI)
Vue.use(VueCookie) // 注册cookie
// 判断是否是移动端
Vue.prototype.$equipment = function () {
  return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
}
Vue.prototype.$md5 = md5
Vue.config.productionTip = false
// 样式导入
import('./assets/style/base.css')
const router = createdRoute()
Vue.config.ignoredElements = ['wx-open-launch-weapp']
new Vue({
  store,
  el: '#app',
  router,
  render: h => h(App),
}).$mount('#app')
